import { render, staticRenderFns } from "./ResponseInbox.vue?vue&type=template&id=92db883c&"
import script from "./ResponseInbox.vue?vue&type=script&lang=js&"
export * from "./ResponseInbox.vue?vue&type=script&lang=js&"
import style0 from "./ResponseInbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports